import { API } from '../helpers/fetcher'

export const idealAuthentication = async params =>
  API.post('v1/transaction/ideal/authenticate', params)

export const adyenIdealAuthentication = async params =>
  API.post('v1/transaction/adyen/ideal/authenticate', params)
